import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../../Hooks/useConfigAuth';
import BotoneraBottom from '../../../../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexFull, ImgB10, AvanzarImg, AvanzarBtn, InputM68, P} from '../../../../../Css/StyledMatematica';

const instrucciones = 'Resuelve la multiplicación.';
const miniInstrucciones = 'Resuelve la multiplicación.';

const M91 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [randomNumeros, setRandomNumeros] = useState('');
    const [informacionEjercicio, setInformacionEjercicio] = useState('');
    const [numero1, setNumero1] = useState('');
    const [numero2, setNumero2] = useState('');
    const [numero3, setNumero3] = useState('');
    const [numero4, setNumero4] = useState('');
    const [numero5, setNumero5] = useState('');
    const [numero6, setNumero6] = useState('');
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [indexes, setIndexes] = useState([]);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [erroresOrden, setErroresOrden] = useState([]);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const sesion = useSelector((state) => state.ejercicio.sesion);
    const lista_usada = useSelector(state => state.informacion.lista_usada);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const verificar = (e) => {
        e.preventDefault();
        
        if(numero1 == randomNumeros[count-1] && numero2 == comparar.cantidad_1 && numero3 == informacionEjercicio[count-1].multiplicacion && numero4 == randomNumeros[count-1] && numero5 == comparar.cantidad_1 && numero6 == informacionEjercicio[count-1].multiplicacion ){
            setDisable(true);
            setIsCorrect(true);
            if(count === 1){
                setErroresOrden([...erroresOrden, contarErrores]);
            } else {
                const err = contarErrores - erroresOrden.reduce((partialSum, a) => partialSum + a, 0);
                setErroresOrden([...erroresOrden, err]);
            }
            GoodWork();
            if(count < indexes){
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setIsCorrect(false);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                    setNumero4('');
                    setNumero5('');
                    setNumero6('');
                }, 1500);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 1500);
            }
        } else {
            setDisable(true);
            setIsIncorrect(true);
            setContarErrores(contarErrores + 1);
            TryAgain();
            setTimeout(() => {
                setIsIncorrect(false);
                setDisable(false);
                setNumero1('');
                setNumero2('');
                setNumero3('');
                setNumero4('');
                setNumero5('');
                setNumero6('');
            }, 300);
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('M91') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/multiplicacion/ejercitacion'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length)
    }, [count, informacion])

    useEffect(() => {
        if(informacion.length === 0) {
            return;
        }
        function shuffle (array) {
            let currentIndex = array.length, randomIndex;
          
            // While there remain elements to shuffle...
            while (currentIndex !== 0) {
          
              // Pick a remaining element...
              randomIndex = Math.floor(Math.random() * currentIndex);
              currentIndex--;
          
              // And swap it with the current element.
              [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
            return array;
        }
        const listaUno = [1,2,3,4,5,6,7,8,9];
        const randomListaUno = shuffle(listaUno);
        setRandomNumeros(randomListaUno);

        const singulares = [
            {"canastas": "canasta"},
            {"nenes": "nene"},
            {"ramas": "rama"},
            {"mesas": "mesa"},
            {"árboles": "árbol"},
            {"zanahorias": "zanahoria"},
            {"manzanas": "manzana"},
            {"koalas": "koala"},
            {"jugos": "jugo"},
            {"flores": "flor"}
        ];

        const singularDict = Object.assign({}, ...singulares);

        let singulares_palabra_1 = [];
        let singulares_palabra_2 = [];

        informacion.forEach(item => {
            singulares_palabra_1.push(singularDict[item.palabra_1]);
            singulares_palabra_2.push(singularDict[item.palabra_2]);
        });

        const infoEjercicio = [
            {"cantidad_dibujos": randomListaUno[0], "multiplicacion": randomListaUno[0]*informacion[0].cantidad_1, "cuenta": `${randomListaUno[0]}x${informacion[0].cantidad_1}`, "palabra_1_singular": singulares_palabra_1[0], "palabra_2_singular": singulares_palabra_2[0]},
            {"cantidad_dibujos": randomListaUno[1], "multiplicacion": randomListaUno[1]*informacion[1].cantidad_1, "cuenta": `${randomListaUno[1]}x${informacion[1].cantidad_1}`, "palabra_1_singular": singulares_palabra_1[1], "palabra_2_singular": singulares_palabra_2[1]},
            {"cantidad_dibujos": randomListaUno[2], "multiplicacion": randomListaUno[2]*informacion[2].cantidad_1, "cuenta": `${randomListaUno[2]}x${informacion[2].cantidad_1}`, "palabra_1_singular": singulares_palabra_1[2], "palabra_2_singular": singulares_palabra_2[2]}
        ]
        setInformacionEjercicio(infoEjercicio);

    }, [informacion])
    
    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                'ejercicio': "M91",
                'errores': contarErrores,
                'tiempo': tiempoFinal,
                'id_paciente': id_paciente,
                'erroresOrden': erroresOrden,
                'info_ejercicio': informacionEjercicio,
                'lista_usada': lista_usada,
                sesion
                }
            }

            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%" align="center">
                    <Flex direction="column" margin="auto" width="100%" align='center' 
                    isCorrect={isCorrect}
                    isIncorrect={isIncorrect}
                    >   
                        <FlexFull justify="space-between" align="center" margin="auto" style={{flexWrap: "wrap"}}>
                            {Array.from({ length: randomNumeros[count-1] }).map((_, i) => (
                                <ImgB10
                                    key={i}
                                    src={`/img/${comparar.imagen_url_1}.png`}
                                    w="6rem"
                                    wd="6rem"
                                    wlg="9rem"
                                    m={i === 0 ? "0" : "1rem 0 0 0"}
                                />
                            ))}
                        </FlexFull>
                        
                        <FlexFull justify="space-evenly" align="center" margin="1rem 0 1rem 0">
                            <FlexFull direction="column" justify="space-between" align="flex-start" margin="auto">
                                <FlexFull>
                                    <P>
                                        Hay{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero1} onChange={(e) => setNumero1(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize:"1.5rem", width: "3rem", textTransform: "uppercase"}} />{" "}
                                        {randomNumeros[count-1] == 1 ? informacionEjercicio[count-1]?.palabra_2_singular : comparar.palabra_2}.
                                    </P>
                                </FlexFull>
                                <FlexFull>
                                    <P>
                                        Cada {informacionEjercicio[count-1]?.palabra_2_singular} tiene{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize:"1.5rem", width: "3rem", textTransform: "uppercase"}} />{" "}
                                        {comparar.cantidad_1 == 1 ? informacionEjercicio[count-1]?.palabra_1_singular : comparar.palabra_1}.
                                    </P>
                                </FlexFull>
                                <FlexFull>
                                    <P>
                                        En total hay{" "}
                                        <InputM68 type="numeric" min="1" max="10" value={numero3} onChange={(e) => setNumero3(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize:"1.5rem", width: "3rem", textTransform: "uppercase"}} />{" "}
                                        {comparar.cantidad_1 == 1 && randomNumeros[count-1] == 1 ? informacionEjercicio[count-1]?.palabra_1_singular : comparar.palabra_1}.
                                    </P>
                                </FlexFull>
                            </FlexFull>
                        </FlexFull>
                        <FlexFull justify="space-between" align="center" margin="0.5rem 0 0.5rem 0">
                            <FlexFull>
                                <InputM68 type="numeric" min="1" max="10" value={numero4} onChange={(e) => setNumero4(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "1.5rem", width: "3rem", margin: "0 0.5rem 0 0.5rem"}} />
                            </FlexFull>
                            <FlexFull direction="column" align="center" justify="center" margin="0.5rem 0.5rem 0.5rem">
                                <P fs="2.5rem" m="0">X</P>
                            </FlexFull>
                            <FlexFull direction="column" align="center" justify="center" >
                                <InputM68 type="numeric" min="1" max="10" value={numero5} onChange={(e) => setNumero5(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "1.5rem", width: "3rem", margin: "0 0.5rem 0 0.5rem"}} />
                            </FlexFull>
                            <FlexFull align="center" justify="center" margin="0.6rem 0.2rem 0.2rem">
                                <P fs="2rem" m="0">=</P>
                            </FlexFull>
                            <FlexFull align="center" justify="center">
                                <InputM68 type="numeric" min="1" max="10" value={numero6} onChange={(e) => setNumero6(e.target.value)} disabled={disable} color='#FF9B2A' bgcolor='#F1F0F0' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "1.5rem", width: "3rem", margin: "0 0.5rem 0 0.5rem"}} />
                            </FlexFull>
                        </FlexFull>
                    </Flex>

                    <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="end">
                        <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                        >
                            <AvanzarImg src={'/img/play.png'} /> 
                        </AvanzarBtn>
                    </Flex>
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default M91;